module.exports = __webpack_public_path__ + "static/media/typescript.4df71244.svg";